import React, { CSSProperties, useCallback, useEffect } from 'react';
import { IconBook, IconCode, IconPlay } from '@edu-frontend/modules/src/components/ui/Icon';
import { ButtonTabs } from '@edu-frontend/modules/src/shared/ui/ButtonTabs';
import { Tab } from '@edu-frontend/modules/src/shared/ui/ButtonTabs';
import { useIntl } from 'react-intl';
import cx from 'classnames';
import { LESSON_HEADER_HEIGHT } from '@edu-frontend/modules/src/features/lessonHeaderMobile';
import { MOBILE_TABS_HEIGHT } from '../../../consts';
import RobotInfo from '../../../__info/robot__info';
import RobotError from '../../../__error/robot__error';
import { Code } from '../../../__code-container/robot__code-container';
import { RobotFieldPane } from '../../../__field-pane/robot__field-pane';
import { useRobotState } from '../../../robotState';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import styles from './robot_view_python_mobile.module.scss';

const TABS = [
    {
        id: 'task',
        title: 'robotProblem.pythonMobile.tabs.task',
        Icon: IconBook,
    },
    {
        id: 'code',
        title: 'robotProblem.pythonMobile.tabs.code',
        Icon: IconCode,
    },
    {
        id: 'robot',
        title: 'robotProblem.pythonMobile.tabs.robot',
        Icon: IconPlay,
    },
] as const;

export const RobotViewPythonMobile = () => {
    const intl = useIntl();
    const { setMobileTab, mobileTab: activeTab } = useRobotState();

    const renderTabContent = useCallback((tabId: Tab['id']) => {
        switch (tabId) {
            case 'task':
                return <RobotInfo mix={styles.info} />;
            case 'code':
                return (
                    <div className={cx(styles.code, 'qa_robot-python-editor')}>
                        <RobotError className={styles.error} />
                        <Code />
                    </div>
                );
            case 'robot':
                return <RobotFieldPane className={styles.fieldPane} />;
            default:
                return null;
        }
    }, []);

    useEffect(() => {
        return () => {
            setMobileTab('task');
        };
    }, [setMobileTab]);

    return (
        <>
            <ButtonTabs
                className={styles.tabs}
                style={{ ['--lesson-mobile-header-height']: LESSON_HEADER_HEIGHT } as CSSProperties}
                tabListLabel={intl.formatMessage({ id: 'a11y.robotProblem.pythonMobile.tabs' })}
                tabMaxWidth
                tabs={TABS.map(({ id, title, Icon }) => ({
                    id,
                    title: intl.formatMessage({ id: title }),
                    icon: <Icon size="m" />,
                    isActive: activeTab === id,
                    onClick: () => setMobileTab(id),
                }))}
            />
            <div
                className={cx(styles.contentWrapper, activeTab === 'robot' && styles.contentWrapper_robot)}
                style={
                    {
                        ['--lesson-mobile-tabs-height']: MOBILE_TABS_HEIGHT,
                    } as CSSProperties
                }
            >
                {renderTabContent(activeTab)}
            </div>
        </>
    );
};
